import RestApiModel from "@/api/Model/RestApiModel";

class ReportType extends RestApiModel {
  static getResourceEndpoint() {
    return '/facility-report-types';
  }
}

export default ReportType;
